import axios from 'axios'
import {all, fork, takeLatest, call, put} from 'redux-saga/effects'
import {API_BASE_URL} from "../constants/config";
import actionTypes from "../constants/actionTypes";


function* youtube(action) {
    try {
        const {projectId} = action.payload;
        const data = yield call(axios.get, `${API_BASE_URL}/youtube?projectId=${projectId}`);
        for (const element of data.data) {
            yield put({
                type: actionTypes.YOUTUBE_ON_RESULT,
                youtubeListId: element?.youtubeId,
                youtubeData: element
            })
        }

    } catch (e) {
    }

}

function* watchYoutube() {
    yield takeLatest(actionTypes.YOUTUBE_ON, youtube)
}

export default function* youtubeSaga(action) {
    yield all([
        fork(watchYoutube)
    ])
}
